export default __webpack_public_path__ + "static/media/Q6_4_resized.1a632c63.jpg";